import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseCandidateActions, baseCandidatesSelectors } from '../../../_store';
import { BaseCandidatesListPayloadInterfaces } from '../_interfaces/base-candidates-list-payload.interfaces';

@Injectable({ providedIn: 'root' })
export class BaseProfilesListGuard {
  constructor(private readonly store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    this.store.dispatch(
      baseCandidateActions.loadCandidates({
        payload: route.queryParams as BaseCandidatesListPayloadInterfaces,
      })
    );

    return this.store.select(baseCandidatesSelectors.getCandidates).pipe(
      filter((state) => state.ok !== undefined),
      map((state) => state.ok as boolean)
    );
  }
}
